import { useStoreMapContext } from '@components/storeMap/provider/StoreMapContext'

import Shelf, { type ShelfProps } from './Shelf'

interface OOSShelfProps extends ShelfProps {
  selectedShelfId?: string
}

function OOSShelf({ shelf, ...props }: OOSShelfProps) {
  const { highlightedShelves } = useStoreMapContext()
  const isSelected = highlightedShelves.includes(shelf.id)

  const noStockCount = shelf.statistics?.noStockCount ?? 0

  let stroke
  let fill

  if (noStockCount > 0) {
    stroke = 'var(--color-out-of-shelf)'
    fill = 'var(--color-out-of-shelf)'
  }

  // not judged: it must not read as "no gaps"
  if (shelf.dayState === 'notCurrent') {
    fill = 'var(--color-shelf-neutral)'
  }

  // workaround to make it possible to have multiple selected shelves
  // e.g. in the product finder im looking for a product that is available in multiple shelves
  // we then could use MarkedShelf again
  if (isSelected) {
    fill = 'var(--color-shelf-selected)'
  }

  return <Shelf state="oos" shelf={shelf} fill={fill} stroke={stroke} {...props} />
}

export default OOSShelf